import type { RootState } from 'src/app/store/types';

export function selectTripEvents(state: RootState) {
  return state.tripSummary.tripEvents;
}
